<template>
    <nav id="UiLayer" :style="[getMaximizedSizeAndOffset]">

        <Logo></Logo>
        <BackButton></BackButton>
        <Agenda></Agenda>
        <AudioToggle></AudioToggle>
        <HelpButton></HelpButton>
        <div class="frame"></div>
    </nav>
</template>
<script>
import Logo from "../ui/Logo.vue";
import BackButton from "../ui/BackButton.vue";
import Agenda from "../ui/Agenda.vue";
import AudioToggle from "../ui/AudioToggle.vue";
import HelpButton from "../ui/HelpButton.vue";

export default {
    components: {
        Logo,
        BackButton,
        Agenda,
        AudioToggle,
        HelpButton
    },
    data() {
        return {
        };
    },
    methods: {},
    computed: {
        onHomePage() {
            this.$route;
            return app.api.PageManager.onHomePage();
        },
        getMaximizedSizeAndOffset() {
            return this.$store.getters.getMaximizedSizeAndOffsetValue;
        },
    }
};
</script>

<style lang="scss">
#UiLayer {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;

    .frame {
        position: absolute;
        z-index: 10;
        top: -1px;
        left: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        pointer-events: none;
        border: 11px solid var(--frame-trans-green);
    }



    * {
        pointer-events: all;
    }
}
</style>